import { COLORS, TEXT_COLORS } from "../../../../constants/design/colors";

export const pnlColor = (pnl: string) => {
  if (pnl && Number(pnl) > 0) {
    return COLORS.up.one;
  }
  if (pnl && Number(pnl) < 0) {
    return COLORS.down.one;
  }
  return TEXT_COLORS.one;
};
